import React, { useState } from "react";
import styles from "../styles/Retail.module.css";
import Header from "../components/Header";
import { Link } from "react-router-dom";
import pic from "../assets/mobile.JPG";
import payment from "../assets/hospi.png";
import view from "../assets/Untitled-3-09.png";
import imag from "../assets/Image wrapper.png";
import see from "../assets/gateway.png";
import Footer from "../components/Footer";

const Transportation = () => {
  const [activeButton, setActiveButton] = useState("Payment in Store");
const getContent = (buttonText) => {
    switch (buttonText) {
      case "Payment on the go":
        return (
          <>
            <h3 className={styles.sideTextHeading}>Mobile POS Solutions</h3>
            <p className={styles.sideTextParagraph}>
              <span className={styles.icon}>✦</span> Enable staff to accept
              payments anywhere in the store, improving customer experience.
            </p>
            <h3 className={styles.sideTextHeading}>Contactless Payments</h3>
            <p className={styles.sideTextParagraph}>
              <span className={styles.icon}>✦</span> Support for mobile wallets,
              and tap-to-pay solutions.
            </p>
          </>
        );

      case "Self Service":
        return (
          <>
            <h3 className={styles.sideTextHeading}>Self-Checkout Kiosks</h3>
            <p className={styles.sideTextParagraph}>
              <span className={styles.icon}>✦</span> Allow customers to scan and
              pay for their items independently.
            </p>
            <h3 className={styles.sideTextHeading}>
              Automated In-Store Ordering
            </h3>
            <p className={styles.sideTextParagraph}>
              <span className={styles.icon}>✦</span> Digital kiosks for in-store
              pickup and pre-ordering.
            </p>
          </>
        );

      case "Commerce Service":
        return (
          <>
            <h3 className={styles.sideTextHeading}>
              Inventory & Store Management
            </h3>
            <p className={styles.sideTextParagraph}>
              <span className={styles.icon}>✦</span> Stock tracking and demand
              forecasting.
            </p>
            <h3 className={styles.sideTextHeading}>
              Loyalty & Rewards Programs
            </h3>
            <p className={styles.sideTextParagraph}>
              <span className={styles.icon}>✦</span> Digital solutions for
              customer engagement, offering discounts and reward points.
            </p>
          </>
        );

      default:
        return (
          <>
            <h3 className={styles.sideTextHeading}>
              Smart POS & Countertop Payments
            </h3>
            <p className={styles.sideTextParagraph}>
              <span className={`${styles.icon} ${styles.green}`}>✦</span>{" "}
              Secure, quick transactions at checkout counters to reduce waiting
              time.
            </p>
            <h3 className={styles.sideTextHeading}>QR Code Payments</h3>
            <p className={styles.sideTextParagraph}>
              <span className={styles.icon}>✦</span> Customers can scan a QR
              code for instant payments, reducing reliance on cash.
            </p>
          </>
        );
    }
  };
  return (
    <div>
      <Header />
      <div className={styles.empoweringSection}>
        <div className={styles.hero}>
          <div className={styles.heroContent}>
            <p className={styles.msmesLabel}>TRANSPORTATION</p>
            <h1 className={styles.heroTitle}>
              Revolutionizing Transportation Payments: Seamless Solutions for a
              Connected Journey
            </h1>
            <Link to="/ContactUs">
              <button className={styles.contactButton}>Contact Us →</button>
            </Link>
          </div>
          <div className={styles.heroImage}>
            <img
              style={{ borderRadius: "40px", width: "550px", height: "300px" }}
              src={pic}
              alt="Payment terminal in a shop"
            />
          </div>
        </div>
      </div>
      <div className={styles.helpingSection}>
        <div className={styles.helpingText}>
          <h2 style={{ fontSize: "24px" }} className={styles.helpingTitle}>
           Arifpay for Transportation
          </h2>
          <p className={styles.helpingDescription}>
        No matter where the journey starts or ends, Arifpay empowers drivers and dispatchers to collect fares with ease whether
         it's through smart POS card payments, scanning customer QR codes, wallet payments like Telebirr or CBE Birr, entering fare codes for app-based rides, or even tracking cash transactions.
            <br />
          </p>
        </div>
      </div>
    <div className={styles.contents}>
  {/* Section 1 - Image Left, Text Right */}
  <section className={styles.thirdLayer}>
    <div className={styles.newContent}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "40px",
        maxWidth: "1200px",
        margin: "0 auto",
        padding: "40px 20px"
      }}
    >
      <div className={styles.solutionImage}>
        <img
          src={payment}
          alt="feature payment"
          style={{
            width: "500px",
            height: "300px",
            borderRadius: "15px",
            objectFit: "cover"
          }}
        />
      </div>
      <div  className={styles.viewText}  style={{ maxWidth: "600px" }}>
        <h2 style={{ 
          fontSize: "24px",
          color: "#333",
          marginBottom: "20px",
          lineHeight: "1.3"
        }}>
     Accept Every Payment Method On the Move
        </h2>
        <p style={{ 
          fontSize: "16px",
          color: "black",
          lineHeight: "1.6",
          marginBottom: "15px"
        }}>
    Digitize fare collection and streamline fleet operations with Arifpay
     whether by deploying our portable smart POS devices for taxis and terminals or integrating seamless payment links directly into your ride or delivery apps.
        </p>
        {/* <p style={{ 
          fontSize: "1.2rem",
          color: "black",
          lineHeight: "1.6"
        }}>
          <span className={styles.icon}>✦</span> Our self-service solutions are built to excel in harsh environments, with round-the-clock operation, empowering your customers to make payments conveniently and securely at any location and time.
        </p> */}
      </div>
    </div>
  </section>

  {/* Section 2 - Text Left, Image Right */}
  <section className={styles.thirdLayer}>
    <div
     className={styles.newContentReverse}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexDirection: "row-reverse",
        gap: "40px",
        maxWidth: "1200px",
        margin: "0 auto",
        padding: "40px 20px"
      }}
    >
      <div className={styles.solutionImageReverse}>
        <img
          src={imag}
          alt="advanced payment"
          style={{
            width: "500px",
            height: "300px",
            borderRadius: "15px",
            border: "6px solid rgba(143, 188, 143, 0.3)",
            objectFit: "cover"
          }}
        />
      </div>
      <div className={styles.viewTextReverse} style={{ maxWidth: "600px" }}>
        <h2 style={{ 
          fontSize: "24px",
          color: "#333",
          marginBottom: "20px",
          lineHeight: "1.3"
        }}>
       Perfect for Drivers, Delivery Agents, and Ticket Booths
        </h2>
        <p style={{ 
          fontSize: "16px",
          color: "black",
          lineHeight: "1.6",
          marginBottom: "15px"
        }}>
      Arifpay ensures instant digital receipts and complete fare transparency providing
      <span className={styles.NewmobileBreak}><br/></span> on-screen fare summaries and tips, sending SMS or email receipts to passengers, and offering full ride and payment logs through <span className={styles.NewmobileBreak}><br/></span> the operator dashboard.
        </p>
        {/* <p style={{ 
          fontSize: "1.2rem",
          color: "black",
          lineHeight: "1.6"
        }}>
          <span className={styles.icon}>✦</span> Effortlessly handle a wide range of digital tickets, from closed-loop cards to NFC devices, contactless tickets, QR codes, and mobile apps, all managed through our comprehensive platform.
        </p> */}
      </div>
    </div>
  </section>

  {/* Section 3 - Image Left, Text Right */}
  <section  className={styles.thirdLayer}>
    <div    className={styles.newContent}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "40px",
        maxWidth: "1200px",
        margin: "0 auto",
        padding: "40px 20px"
      }}
    >
      <div className={styles.solutionImage}>
        <img
          src={view}
          alt="feature payment"
          style={{
            width: "90%",
            height: "300px",
            borderRadius: "15px",
            objectFit: "cover"
          }}
        />
      </div>
      <div className={styles.viewText} style={{ maxWidth: "600px" }}>
        <h2 style={{ 
          fontSize: "24px",
          color: "#333",
          marginBottom: "20px",
          lineHeight: "1.3"
        }}>
      Instant Digital Receipts & Fare Transparency
        </h2>
        <p style={{ 
          fontSize: "16px",
          color: "black",
          lineHeight: "1.6",
          marginBottom: "15px"
        }}>
      With Arifpay’s real time revenue tracking, you always know how much your 
      fleet or drivers are earning <span className={styles.NewmobileBreak}><br/></span> through daily, weekly, and trip based reports, performance breakdowns by driver, route, or region, and clear visibility into refunds, voids, and cash splits.
        </p>
        {/* <p style={{ 
          fontSize: "1.2rem",
          color: "black",
          lineHeight: "1.6"
        }}>
          <span className={styles.icon}>✦</span> 24/7 ticket purchasing capabilities are also available with our self-service solutions.
        </p> */}
      </div>
    </div>
  </section>

  {/* Section 4 - Text Left, Image Right */}
  <section className={styles.thirdLayer}>
    <div className={styles.newContentReverse}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexDirection: "row-reverse",
        gap: "40px",
        maxWidth: "1200px",
        margin: "0 auto",
        padding: "40px 20px"
      }}
    >
      <div className={styles.borderImage} >
        <img
          src={see}
          alt="feature payment"
          style={{
            width: "100%",
            height: "300px",
            borderRadius: "15px",
            objectFit: "cover"
          }}
        />
      </div>
      <div className={styles.viewText} style={{ maxWidth: "600px" }}>
        <h2 style={{ 
          fontSize: "24px",
          color: "#333",
          marginBottom: "20px",
          lineHeight: "1.3"
        }}>
        Real-Time Revenue Tracking
        </h2>
        <p style={{ 
          fontSize: "16px",
          color: "black",
          lineHeight: "1.6",
          marginBottom: "15px"
        }}>
       Integrate Arifpay seamlessly into your transportation platform connecting effortlessly with dispatch, booking, or fleet systems through secure APIs that support ride hailing apps, ERP tools, and ticketing kiosks or booking terminals.
        </p>
        {/* <p style={{ 
          fontSize: "1.2rem",
          color: "black",
          lineHeight: "1.6"
        }}>
          <span className={styles.icon}>✦</span> Achieve maximum terminal availability and uptime with a secure remote estate management solution.
        </p> */}
      </div>
    </div>
  </section>
</div>

      <section className={styles.buttonSection}>
            <div className={styles.buttonContainer}>
              <div className={styles.buttonText}>
                <p className={styles.subheading}>
                  FASTER, SAFER, AND SMARTER SOLUTIONS
                </p>
                <h2 className={styles.buttonHeader}>Industry Specific Solutions</h2>
                <p className={styles.buttonParagraph}>
                  Transportation businesses rely on speed, security, and automation
                  in fare collection. Our payment solutions support effortless
                  transactions for commuters, logistics, and mobility platforms.
                </p>
              </div>
    
              <div className={styles.buttonAndText}>
                <div className={styles.buttonGroup}>
                  <div className={styles.mobileButtonSlider}>
                    {[
                      "Payment in Store",
                      "Payment on the go",
                      "Self Service",
                      "Commerce Service",
                    ].map((btn) => (
                      <button
                        key={btn}
                        className={`${styles.industryButton} ${
                          activeButton === btn ? styles.activeIndustryButton : ""
                        }`}
                        onClick={() => setActiveButton(btn)}
                        style={{
                          backgroundColor:
                            activeButton === btn ? "var(--primary-green)" : "",
                          color: activeButton === btn ? "white" : "",
                        }}
                      >
                        {btn} <span className={styles.buttonIcon}>→</span>
                      </button>
                    ))}
                  </div>
                </div>
    
                <div className={styles.mobileButtonContent}>
                  {getContent(activeButton)}
                </div>
              </div>
            </div>
          </section>
    

      <section className={styles.bottom}>
        <div
          className={styles.bottom}
          style={{
            backgroundColor: "var(--primary-green)",
            color: "#fff",
            padding: "20px 30px",
            borderRadius: "35px",
            margin: "40px 70px 65px 50px",
          }}
        >
          <div
            style={{
              maxWidth: "1200px",
              margin: "0 auto",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
            }}
          >
            {/* Text Content */}
            <div style={{ flex: "1", maxWidth: "550px", marginBottom: "30px" }}>
              <h2
                style={{
                  fontSize: "3em",
                  marginBottom: "15px",
                  color: "white",
                }}
              >
                Become a partner
              </h2>
              <p style={{ fontSize: "1.4em" }}>
                <span style={{ color: "white", fontSize: "0.8em" }}>✦</span>{" "}
                Become a partner right for you, who understands your unique
                business and industry needs.
              </p>

              <Link to="/become-a-partner">
                <button
                  className={styles.but}
                  style={{
                    backgroundColor: "#fff",
                    color: "green",
                    border: "none",
                    padding: "15px 30px",
                    borderRadius: "5px",
                    fontSize: "16px",
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                  onMouseEnter={(e) =>
                    (e.target.style.backgroundColor = "var(--primary-green)")
                  }
                  onMouseLeave={(e) =>
                    (e.target.style.backgroundColor = "#fff")
                  }
                >
                  Become a partner →
                </button>
              </Link>
            </div>

            {/* Image Side */}
            <div
              style={{ flex: "1", display: "flex", justifyContent: "flex-end" }}
            >
              <img
                src={view} // your actual image path
                alt="Payment Terminal"
                style={{
                  width: "100%",
                  maxWidth: "450px",
                  height: "auto",
                  objectFit: "cover",
                  borderRadius: "25px",
                  border: "5px solid green",
                }}
              />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Transportation;



// "use client";
// import axios from "axios";
// import { useEffect, useState, useRef } from "react";
// import { useParams, useLocation, useNavigate } from "react-router-dom";
// import Footer from "../components/Footer";
// import Header from "../components/Header";
// import JobApplicationForm from "../components/JobApplicationForm";
// import styles from "../styles/Jobs.module.css";

// const Jobs = () => {
//   const [jobs, setJobs] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [selectedJob, setSelectedJob] = useState(null);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [filter, setFilter] = useState("All");
//   const [sessionId, setSessionId] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [showApplicationForm, setShowApplicationForm] = useState(false);
//   const [totalJobs, setTotalJobs] = useState(0);
//   const [expandedJobs, setExpandedJobs] = useState(new Set());
//   const jobRefs = useRef({}); // Store references to job sections

//   const location = useLocation();
//   const navigate = useNavigate();
//   const { jobId, slug } = useParams(); // Get jobId and slug from URL
//   const jobsPerPage = 5;

//   // Helper function to create URL-friendly slug
//   const createSlug = (title) => {
//     return title
//       .toLowerCase()
//       .replace(/[^a-z0-9]+/g, "-")
//       .replace(/(^-|-$)/g, "");
//   };

// // Inside the Jobs component

// // Scroll to job section when navigating to /jobs/:jobId/:slug
// useEffect(() => {
//   if (jobId && jobs.length > 0) {
//     const targetJob = jobs.find((j) => (j._id || j.id) === jobId);
//     if (targetJob && jobRefs.current[jobId]) {
//       jobRefs.current[jobId].scrollIntoView({ behavior: "smooth" });
//       const expectedSlug = createSlug(targetJob.title);
//       if (slug !== expectedSlug) {
//         navigate(`/jobs/${jobId}/${expectedSlug}`, { replace: true });
//       }
//     } else {
//       // Redirect to /jobs if jobId is invalid
//       navigate("/jobs");
//     }
//   } else {
//     window.scrollTo(0, 0); // Scroll to top for /jobs
//   }
// }, [jobId, slug, jobs, navigate]);

// // Set up Intersection Observer to update URL when job section is visible
// useEffect(() => {
//   const observer = new IntersectionObserver(
//     (entries) => {
//       entries.forEach((entry) => {
//         if (entry.isIntersecting) {
//           const jobId = entry.target.getAttribute("data-job-id");
//           const job = jobs.find((j) => (j._id || j.id) === jobId);
//           if (job) {
//             const slug = createSlug(job.title);
//             const currentPath = `/jobs/${jobId}/${slug}`;
//             // Only update URL if it differs
//             if (location.pathname !== currentPath) {
//               navigate(currentPath, { replace: true });
//               console.log("Navigated to:", currentPath); // Debug log
//             }
//           }
//         }
//       });
//     },
//     {
//       root: null, // Use viewport as root
//       threshold: 0.5, // Reduced to 50% to make it easier to trigger
//       rootMargin: "0px", // No margin adjustment
//     }
//   );

//   // Observe each job section
//   Object.values(jobRefs.current).forEach((ref) => {
//     if (ref) {
//       observer.observe(ref);
//       console.log("Observing job with ID:", ref.getAttribute("data-job-id")); // Debug log
//     }
//   });

//   // Cleanup observer on unmount
//   return () => {
//     Object.values(jobRefs.current).forEach((ref) => {
//       if (ref) observer.unobserve(ref);
//     });
//   };
// }, [jobs, navigate, location.pathname]);

//   const handleApplyClick = (job) => {
//     setSelectedJob(job);
//     setShowApplicationForm(true);
//   };

//   const handleCloseApplicationForm = () => {
//     setShowApplicationForm(false);
//     setSelectedJob(null);
//   };

//   const toggleJobExpansion = (jobKey) => {
//     setExpandedJobs((prev) => {
//       const newSet = new Set(prev);
//       if (newSet.has(jobKey)) {
//         newSet.delete(jobKey);
//       } else {
//         newSet.add(jobKey);
//       }
//       return newSet;
//     });
//   };

//   const truncateHtmlContent = (htmlContent, maxLength = 200) => {
//     if (!htmlContent) return "";
//     const textContent = htmlContent.replace(/<[^>]*>/g, "");
//     if (textContent.length <= maxLength) return htmlContent;

//     let truncateAt = maxLength;
//     const sentences = textContent.split(/[.!?]+/);
//     let currentLength = 0;

//     for (let i = 0; i < sentences.length; i++) {
//       const sentenceLength = sentences[i].length + 1;
//       if (currentLength + sentenceLength > maxLength) break;
//       currentLength += sentenceLength;
//       truncateAt = currentLength;
//     }

//     if (truncateAt === maxLength) {
//       const words = textContent.substring(0, maxLength).split(" ");
//       words.pop();
//       const truncatedText = words.join(" ");
//       return htmlContent.includes("<p>")
//         ? `<p>${truncatedText}...</p>`
//         : `${truncatedText}...`;
//     }

//     const truncatedText = textContent.substring(0, truncateAt);
//     return htmlContent.includes("<p>")
//       ? `<p>${truncatedText}...</p>`
//       : `${truncatedText}...`;
//   };

//   const getNewSessionId = async () => {
//     try {
//       const response = await axios.post(
//         `${import.meta.env.VITE_API_BASE_URL}/web/session/authenticate`,
//         {
//           jsonrpc: "2.0",
//           params: {
//             db: "ProdClone",
//             login: import.meta.env.VITE_API_AUTH_USERNAME,
//             password: import.meta.env.VITE_API_AUTH_PASSWORD,
//           },
//         },
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//           withCredentials: true,
//         }
//       );
//       const match = document.cookie.match(/(?:^|;\s*)session_id=([^;]*)/);
//       return match ? match[1] : "cookie-managed";
//     } catch (error) {
//       console.error("Failed to get session ID:", error);
//       return null;
//     }
//   };

//   const fetchJobs = async (page = 1) => {
//     setLoading(true);
//     try {
//       const response = await axios.post(
//         `${import.meta.env.VITE_API_BASE_URL}/api/jobs`,
//         {
//           page,
//           per_page: jobsPerPage,
//         },
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//           withCredentials: true,
//         }
//       );
//       const jobList = response.data?.result?.result?.jobs ?? [];
//       const total = response.data?.result?.result?.total ?? 0;
//       setJobs(jobList);
//       setTotalJobs(total);
//       setTotalPages(Math.ceil(total / jobsPerPage));
//     } catch (err) {
//       console.error("Failed to fetch jobs", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     const initializeSession = async () => {
//       const newSessionId = await getNewSessionId();
//       if (newSessionId) setSessionId(newSessionId);
//     };
//     initializeSession();
//   }, []);

//   useEffect(() => {
//     if (sessionId) {
//       fetchJobs(currentPage);
//     }
//   }, [currentPage, sessionId]);

//   const handlePrevPage = () => {
//     if (currentPage > 1) setCurrentPage((prev) => prev - 1);
//   };

//   const handleNextPage = () => {
//     if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
//   };

//   return (
//     <div>
//       <Header />
//       <div className={styles.container}>
//         <div className={styles.maxWidth}>
//           <p className={styles.blogTitle}>ARIF JOBS</p>
//           <h2 className={styles.heading}>
//             Arif Jobs: be a part of
//             <span className={styles.mobileBreak}><br /></span> our community
//           </h2>
//         </div>
//       </div>

//       {loading ? (
//         <p style={{ textAlign: "center", margin: "2rem" }}>Loading jobs...</p>
//       ) : jobs.length === 0 ? (
//         <p style={{ textAlign: "center", margin: "2rem" }}>
//           {sessionId ? "No jobs found." : "Failed to load jobs. Please refresh."}
//         </p>
//       ) : (
//         jobs.map((job, index) => {
//           const jobKey = job._id || job.id || index;
//           const formattedDate = job.createdAt ? new Date(job.createdAt).toLocaleDateString() : null;
//           const isExpanded = expandedJobs.has(jobKey);
//           const jobDescription = job.description || "<p>No description available</p>";
//           const shouldShowReadMore = jobDescription.replace(/<[^>]*>/g, "").length > 200;

//           return job.is_published ? (
//             <div
//               key={jobKey}
//               className={styles.internationalPaymentsSection}
//               data-job-id={jobKey}
//               ref={(el) => (jobRefs.current[jobKey] = el)} // Assign ref to job section
//             >
//               <div className={styles.paymentDetails}>
//                 <h2 style={{ marginTop: "0" }}>{job.title}</h2>

//                 <div style={{ marginTop: "8px", color: "black" }}>
//                   {/* <h3>
//                     <strong style={{ fontSize: "16px" }}>Job Summary:</strong>
//                   </h3> */}

//                   <div
//                     dangerouslySetInnerHTML={{
//                       __html: isExpanded
//                         ? jobDescription
//                         : truncateHtmlContent(jobDescription, 200),
//                     }}
//                   />

//                   {shouldShowReadMore && (
//                     <button
//                       onClick={() => toggleJobExpansion(jobKey)}
//                       style={{
//                         background: "none",
//                         border: "none",
//                         color: "var(--primary-green, #007bff)",
//                         cursor: "pointer",
//                         textDecoration: "underline",
//                         fontSize: "14px",
//                         marginTop: "8px",
//                         padding: "0",
//                       }}
//                     >
//                       {isExpanded ? "Read Less" : "Read More"}
//                     </button>
//                   )}
//                 </div>

//                 {job.location && (
//                   <div className={styles.locationContainer}>
//                     <p className={styles.locationText}>{job.location}</p>
//                   </div>
//                 )}

//                 {formattedDate && (
//                   <div className={styles.locationContainer}>
//                     <p className={styles.locationText}>{formattedDate}</p>
//                   </div>
//                 )}

//                 <button
//                   onClick={() => handleApplyClick(job)}
//                   style={{
//                     backgroundColor: "green",
//                     color: "white",
//                     padding: "10px 20px",
//                     border: "none",
//                     borderRadius: "10px",
//                     marginTop: "20px",
//                     cursor: "pointer",
//                   }}
//                 >
//                   Apply Now →
//                 </button>
//               </div>
//             </div>
//           ) : null;
//         })
//       )}

//       <div className={styles.pagination}>
//         <button
//           onClick={handlePrevPage}
//           disabled={currentPage === 1}
//           className={styles.paginationButton}
//         >
//           Previous
//         </button>
//         <span>Page {currentPage} of {totalPages}</span>
//         <button
//           onClick={handleNextPage}
//           disabled={currentPage === totalPages}
//           className={styles.paginationButton}
//         >
//           Next
//         </button>
//       </div>

//       <JobApplicationForm
//         jobTitle={selectedJob?.title || ""}
//         jobId={selectedJob?.id || ""}
//         isOpen={showApplicationForm}
//         onClose={handleCloseApplicationForm}
//       />

//       <Footer />
//     </div>
//   );
// };

// export default Jobs;
